<template>
<svg
  width="18px"
  height="18px"
  viewBox="0 0 24 24"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  fill="#FF0000"
  :class="{pinned: isPinned}"
  @click="$emit('click')"
>
  <title>Combined Shape</title>
  <g id="Suggested-phrases-(Adding-phrase)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="SP-4-–-Pinned-suggested-" transform="translate(-945.000000, -399.000000)" fill="#C6C6C6" fill-rule="nonzero">
          <g id="Modal" transform="translate(370.000000, 147.000000)">
              <g id="Table" transform="translate(24.000000, 106.000000)">
                  <g id="Segment-center" transform="translate(0.000000, 140.000000)">
                      <g id="Table/Cell/Center" transform="translate(36.000000, 0.000000)">
                          <path d="M539,6 L539,30 L515,30 L515,6 L539,6 Z M532,8 L522,8 C521.45,8 521,8.45 521,9 C521,9.55 521.45,10 522,10 L523,10 L523,15 C523,16.38 522.07,17.54 520.8,17.89 C520.34,18.02 520,18.4 520,18.87 L520,19 C520,19.55 520.45,20 521,20 L525.98,20 L526,27 C526,27.55 526.45,28 527,28 C527.55,28 528,27.55 528,27 L527.98,20 L533,20 C533.55,20 534,19.55 534,19 L534,18.87 C534,18.4 533.66,18.02 533.2,17.89 C531.93,17.54 531,16.38 531,15 L531,10 L532,10 C532.55,10 533,9.55 533,9 C533,8.45 532.55,8 532,8 Z" id="Combined-Shape"></path>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </g>
</svg>
</template>

<script lang="javascript">
export default {
  props: {
    isPinned: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  g {
    fill: #FFFFFF;
  }

  svg {
    margin-right: 8px;
    background-color: $or-grey;

    &.pinned {
      background-color: $or-black-blue;
    }

    &:hover {
      cursor: pointer;
    }

    &:hover:not(.pinned) {
      background-color: $or-grey-dark;
    }
  }
</style>
